import React from 'react';
import { CircularProgress } from '@mui/material';
var LoadingSpinner = function LoadingSpinner() {
  return /*#__PURE__*/React.createElement(CircularProgress, null);
};
export default LoadingSpinner;